/**
 * event bus
 */
export default class EventBus {
    private cache: {
        [name: string] : Function[]
    } = { };

    /**
     * add event listener
     * @param name event name
     * @param fn callback function
     */
    on(name: string, fn: Function): () => void {
        if (!this.cache[name]) {
            this.cache[name] = [];
        }
        this.cache[name].push(fn);
        return () => {
            this.off(name, fn);
        };
    }

    /**
     * remove event listener
     * @param name event name
     * @param fn callback function
     */
    off(name: string, fn: Function) {
        if (this.cache[name]) {
            if (fn) {
                for (let i = this.cache[name].length; i >= 0; i--) {
                    if (this.cache[name][i] === fn) {
                        this.cache[name].splice(i, 1);
                    }
                }
            } else {
                this.cache[name] = [];
            }
        }
    }

    /**
     * trigger event
     * @param name event name
     * @param args event arguments
     */
    emit(name: string, ...args: any[]) {
        let stack: Function[] = [];
        Object.assign(stack, this.cache[name]);
        if (!stack || !stack.length) {
            return;
        }
        for (let i = 0; i < stack.length; i++) {
            try {
                stack[i].apply(null, args);
            } catch (e) {
                throw e;
            }
        }
    }
}